import React, { Fragment } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { partition } from 'lodash'

import Question from 'modules/questionnaires/components/Question'
import Section from 'modules/questionnaires/components/Section'
import {
  QuestionnaireContent,
  QuestionnaireElement,
  Section as SectionValue,
  Translations,
} from 'modules/questionnaires/lib/types'

export const Questionnaire: React.FC<{
  content: QuestionnaireContent
  translations: Translations
  renderSectionHeaderAddon?: (sectionId: string) => React.ReactNode | undefined
}> = ({ content = [], translations, renderSectionHeaderAddon }) => {
  const [employeeScoreContent, questionnaireContent] = partition(content, 'isEmployeeScore')
  const isSection = (item: QuestionnaireElement): item is SectionValue => 'questions' in item

  return (
    <Box>
      <Box gap="s24">
        {questionnaireContent.map((item) => (
          <Fragment key={item.uuid}>
            {isSection(item) ? (
              <Section
                renderHeaderAddon={renderSectionHeaderAddon}
                key={item.uuid}
                section={item}
                disabled
                translations={translations}
                locked
                hideLockedIcon
                editing={false}
              />
            ) : (
              <Question
                key={item.uuid}
                question={item}
                disabled
                translations={translations.question}
                editing={false}
              />
            )}
          </Fragment>
        ))}
      </Box>

      {employeeScoreContent.map(
        (item) =>
          isSection(item) && (
            <Section
              key={item.uuid}
              section={item}
              translations={translations}
              locked
              renderHeaderAddon={renderSectionHeaderAddon}
            />
          )
      )}
    </Box>
  )
}
